<template>
  <div class="yunxiao parent login">
    <h2 class="title">欢迎使用小云爱学</h2>
    <p class="slogan">随时随地，学员情况全掌握</p>
    <form @submit.prevent="doLogin" method="post" action="" autocomplete="off" autocorrect="off">
      <input
        class="input-line"
        type="tel"
        placeholder="请输入手机号码"
        v-model="phone"
        maxlength="11"
      />
      <div class="input-line cord-input-line">
        <input
          type="tel"
          ref="codeInput"
          maxlength="4"
          v-model="verifyCode"
          placeholder="请输入验证码"
        />
        <p class="reget-code">
          <van-count-down
            ref="getCodeCountDown"
            millisecond
            v-if="showGetCodeCountDown"
            :time="60 * 1000"
            auto-start
            format="重新获取(ss)"
            @finish="countDownFinish"
          />
          <span v-else @click="getCodeVerify">
            {{ getCodedStatus === 'never' ? '获取验证码' : '重新获取' }}
          </span>
        </p>
      </div>
      <span v-if="pcode">{{ pcode }}</span>
      <van-button
        :disabled="!phone"
        square round
        class="confirm-btn"
        type="primary"
        block
        native-type="submit"
      >
        登 录
      </van-button>
      <div class="tips">新用户使用手机号码验证登录即注册小云爱学</div>
    </form>
    <van-dialog
      v-model="showHumanVerificationDialog"
      :show-confirm-button="false"
      show-cancel-button
    >
      <template #default>
        <div class="humanverification-dialog-content">
          <dragVerify v-if="showHumanVerificationDialog" @success="humanVerified" />
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import dragVerify from '@x3/vue/comp/drag-verify.vue';

export default {
  components: {
    dragVerify,
  },
  name: 'parentLogin',
  data() {
    let query = app.tool.parseQuery();
    return {
      pageTitle: '小云爱学',
      companyId: query.companyId,

      phone: '',
      pcode: '',
      verifyCode: '',
      showGetCodeCountDown: false,
      showHumanVerificationDialog: false,
      // 获取验证码状态，never从未获取，once 获取过一次
      getCodedStatus: 'never',

      // 传入的需重定向的地址
      redirect: decodeURIComponent(this.$route.query.redirect || ''),
      wxOpenId: this.$route.query.wxOpenId,
      thirdAppId: this.$route.query.thirdAppId,
    };
  },
  methods: {
    // 验证手机号码是否正确
    telVerifyHandle(phone) {
      // if (!/^1[3456789]\d{9}$/.test(this.phone)) {
      //   this.$toast('请输入正确的手机号码');
      //   return false;
      // }
      if (!/^\d{11}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号码');
        return false;
      }
      return true;
    },
    humanVerified() {
      // 延迟关闭滑块框，避免成功后马上就会关闭弹窗
      this.delayCloseDialog = setTimeout(() => {
        this.showHumanVerificationDialog = false;
      }, 1000);
      this.doGetCode();
    },
    doGetCode() {
      vant.Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
      });
      this.$api
        .codeSms({
          phone: this.phone,
        })
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('发送成功');
            // 发送成功，重新倒计时(考虑重新获取)
            this.showGetCodeCountDown = true;
            this.$refs.codeInput.focus();
            this.pcode = res.data;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg);
          }
        });
    },
    getCodeVerify() {
      if (this.telVerifyHandle(this.phone)) {
        this.showHumanVerificationDialog = true;
      }
    },
    // 倒计时完成，获取验证码设置为可用
    countDownFinish() {
      this.showGetCodeCountDown = false;
    },
    // 登录
    doLogin() {
      const { verifyCode, phone } = this;
      let notify = this.$toast.loading({
        message: '登录中...',
        duration: 0,
        forbidClick: true,
      });
      this.$api
        .parentLogin({
          companyId: this.companyId,
          verifyCode: verifyCode,
          phone: phone,
          wxOpenId: this.wxOpenId,
          thirdAppId: this.thirdAppId,
        })
        .then(res => {
          notify.clear();
          if (res.code === 200) {
            // 保存token
            app.ls.set('x3-parent-token', res.data.token);

            // url带了跳转到登录页面的URL地址，刚跳转到该页
            if (this.redirect) {
              // 将redirect解析
              let parse_url =
                /^(?:([A-Za-z]+):)?(\/+)([\d-.\-A-Za-z]+)(?::(\d+)?)?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?/;
              let url = this.redirect;
              let result = parse_url.exec(url);
              let names = ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash'];
              let urlObj = {};
              for (var i = 0; i < names.length; i++) {
                urlObj[names[i]] = result[i];
              }

              // 将query参数的companyId重新拼装；
              let query = app.tool.parseQuery(urlObj.query);
              query.companyId = res.data.companyId;
              let search = app.tool.jsonToQueryStr(query);
              let { scheme, slash, host, path } = urlObj;
              let redirectUrl = [
                scheme,
                ':',
                slash,
                host,
                urlObj.port ? ':' + urlObj.port + '/' : '/',
                path,
                search,
                urlObj.hash ? '#' + urlObj.hash : '',
              ].join('');
              location.replace(redirectUrl);
            } else {
              let query = app.tool.parseQuery();
              query.companyId = res.data.companyId;
              let search = app.tool.jsonToQueryStr(query);
              // 跳转到家长端首页
              location.replace(`${location.origin}/app/parent${search}`);
            }
          } else if (res.msg) {
            this.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          console.log('登录接口出错', err);
          notify.clear();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.yunxiao.parent.login {
  height: 100%;
  min-height: 550px;
  padding: 50px 30px 0;
  overflow: hidden;
  color: var(--g8);
  font-size: var(--fs-md);
  overflow: hidden;
  background: var(--white) url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/00001.png)
    left bottom/100% auto no-repeat;
  h2.title {
    margin: 0 0 4px;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    color: var(--g8);
  }
  p.slogan {
    margin: 0;
    line-height: var(--lh-md);
    font-size: var(--fs-md);
    color: var(--g6);
  }
  > form {
    margin-top: 24px;
    input {
      padding: 0;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      color: var(--black);
      box-shadow: unset;
      border: unset;
      line-height: 1;
      font-size: var(--fs-lg);
      background: transparent;
      outline: unset;
      &::placeholder {
        color: var(--g5);
        padding-top: 3px;
      }
    }
    .input-line {
      margin-bottom: 16px;
      display: flex;
      height: 46px;
      border-bottom: 1px solid var(--g3);
    }
    .cord-input-line {
      display: flex;
      align-items: center;
      .reget-code {
        box-sizing: border-box;
        margin: 0;
        min-width: 90px;
        height: 22px;
        border-left: 1px solid var(--g3);
        white-space: nowrap;
        padding-left: 8px;
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--c1);
      }
    }
    .van-count-down {
      color: var(--g5);
    }
    > button {
      margin-top: 50px;
      background-color: var(--c5);
      border-color: var(--c5);
    }
  }
  .humanverification-dialog-content {
    padding: 32px 16px;
  }
  .tips {
    padding: calc(var(--gap) * 16);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
  }
}
</style>